import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "./components/UserContext";

function ProtectedRoute ({ children }) {
  const {user} = useUser();

  return user ? children : <Navigate to="/sign-in" replace />;
}

export default ProtectedRoute;
